import store from '@/store/';

/** Whether a scheduled message is an image whose file is stored on Firebase. */
export function isScheduledImage (message) {
    return !!message && !!message.data && (message.mime_type || '').indexOf('image/') === 0;
}

/**
 * Loads a scheduled image for display, as a data URL. Its data is the Firebase file name
 * ("scheduled_<id>", from both web and Android), which MediaLoader downloads and decrypts like
 * message media. Unlike MediaLoader.getMedia, rejects when the download or decrypt fails.
 */
export function loadScheduledImage (message) {
    const loader = store.state.media_loader;
    return loader.getMediaFromStore(message.data)
        .catch(() => loader.getMediaFromServer(message.data))
        .then(blob => 'data:' + message.mime_type + ';base64,' + blob);
}
